import { Button, buttonClasses, styled, Typography } from '@mui/material';
import { FormattedNumber } from 'react-intl';

interface Props {
  quantity: number;
}

const DisabledQuantityButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'quantity',
})<{ quantity: number }>(({ quantity, theme }) => ({
  transition: theme.transitions.create(['color']),
  border: 'none',
  minWidth: 32,
  height: 40,
  textDecoration: 'none',
  padding: 0,
  [`&.${buttonClasses.disabled}`]: {
    border: 'none',
    color:
      quantity > 0
        ? theme.vars.palette.grey[400]
        : theme.vars.palette.grey[800],
  },
}));

const QuantityIndicator = ({ quantity }: Props) => {
  return (
    <DisabledQuantityButton variant="outlined" disabled quantity={quantity}>
      <Typography variant="h7">
        <FormattedNumber value={quantity} />
      </Typography>
    </DisabledQuantityButton>
  );
};

export default QuantityIndicator;
